var _image;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleMeet2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 38,
    height: 30,
    xmlSpace: "preserve",
    viewBox: "0 0 38 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 38,
    height: 30,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAeCAMAAAB3ypxcAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAThQTFRFAAAA5Ts0+8Au/MAt98At4jo15Tk1+8At+b8t5Tk05Tk05Tk1+8At//8AVapVSq5RTK9Q5Tg45Dk1/8wzSK9QS69QTK9QTK5Q5Tk55Dk0Sq9QTK5Q6TY25Dg0TbBP5jUx5Dg1f7ZJS65R4zcy5jk17rwtT7BPxkdV3Ds83Tw8+8At+8Et27UtTogxS65PHYnmHojl0rMuRIQxLn0yS65PoaMvNn8yk54w8bwtY44x47gtUokxwa0vPIExRKFIMYM1TLBPSKlMM4Q3S6xPN4s6PZZBPZdBL34zR6ZLFWbBFWbBTK9QTLBQTK5RMoQ2FWXAFWXASqxOTK5QS65PM8wzTK9QT7BPTK5QS69QFGbBS65PAP8AXbldTK5PS65RF2e+FWW/TK9QFmnDFWS/FGS/TK9QTK5PS69QHIBAFgAAAGh0Uk5TACeysWU17f+DMe//9AEMoYMy7QUg3f/WMe4w4y/ucT7tDo4u+/+7NuT47vv///62////////////////sv+x/7H//////////7L37u73/7b//8CBBW8q4N+l9wELl4FD940im6iyq2nBl209AAABJElEQVR4nI3UPUsDQRAG4PdFUwgaEFJIkKQQCSiaaGOhhBRJIRZWCoIg+K+srOz8DYoYAnZWVhZio6CJUYM5v8BNdjasepedKXYW5rljd/b2CAkSf4P8Gkwlp2KYqUa/2Zj3pBcpvpoxTXnHJN8RxzDeBDIUNsUXJLIsP+3Cp9lCIstFsPvL8wFJLMsOLJvhHZJYjm1YVnCd8BvC636aJe+FFV350mMjo71xzuzwNsgW+Y0wK/UWG2JL/ECYrchpDmdrfIOClW1XQ6xCPmvY1QKfNAwotlQMJT5qGJa7nQFbd8y/DLzop/mJG3f0m67awP9YZV3DENXONax8vHWmYtjmqYYhUz0hd7pDWJVHZtw1X/Ge3IpYtnEoE2JfGhb3qzlw0x/gYlm1/E809gAAAABJRU5ErkJggg=="
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleMeet2);
export default __webpack_public_path__ + "static/media/google_meet_2.699e8a7260b163d33861e044c7b8da4b.svg";
export { ForwardRef as ReactComponent };